import queryString from 'query-string';


import {
  buildCreateApi,
  coreModule,
  fetchBaseQuery,
  reactHooksModule
} from '@reduxjs/toolkit/query/react';

const createApi = buildCreateApi(
  coreModule(),
  reactHooksModule({ unstable__sideEffectsInRender: true })
)

// initialize an empty api service that we'll inject endpoints into later as needed
const createEmptySplitApi = () => {
  const baseUrl = process.env.GATSBY_SEEKA_BACKEND_API_URL || "https://api.seeka.services"
  // console.log("API URL: ", baseUrl)
  return createApi({
    reducerPath: 'appApi',
    baseQuery: fetchBaseQuery(
      {
        baseUrl,
        prepareHeaders(headers, api) {
          return headers;
        },
        paramsSerializer(params) {
          return queryString.stringify(params);
        },
      }),
    endpoints: () => ({}),
  })
}

export const emptySplitApi = createEmptySplitApi();